<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem

========================================================================================== -->

<template>
  <div
    v-if="canSee"
    class="vs-sidebar--item"
    :class="[
      {'vs-sidebar-item-active'            : activeLink},
      {'disabled-item pointer-events-none' : isDisabled}
    ]" >

      <router-link
        v-if="to"
        exact
        :class="[{'router-link-active': activeLink}]"
        :to="to"
        :target="target" >
          <vs-icon class="mr-4" v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
          <slot />
      </router-link>

      <a v-else :target="target" :href="href">
        <vs-icon class="mr-1" v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
        <slot />
      </a>
  </div>
</template>

<script>
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    slug        : { type: String,                 default: null             },
    index       : { type: [String, Number],       default: null             },
    featherIcon : { type: Boolean,                default: true             },
    target      : { type: String,                 default: '_self'          },
    isDisabled  : { type: Boolean,                default: false            },
  },
  computed: {
    canSee() {
		if (this.to) {
			const to = this.$router.match(this.to.path);
			if (!this.$acl.check(to.meta.rule)) {
				return false;
			}
			if (to.meta.authRequired && to.meta.permissionKey && !this.$store.getters['auth/hasPermission'](to.meta.permissionKey)) {
				return false;
			}
		}
		return true
    },
    activeLink() {
      return !!((this.to.path === this.$route.path) || (this.$route.meta.parent === this.slug) && this.to)
    }
  }
}

</script>

<style lang="scss" scoped>
	.vs-sidebar--item {
		svg {
			stroke-width: 4px;
		}

		&:not(.vs-sidebar-item-active) {
			svg {
				color: var(--color-solid-primary);
			}
		}
	}
</style>
